var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tab,{ref:"grid",tag:"component"},[_vm._l((_vm.gridList),function(data,index){return _vm._t("default",null,{"data":_vm.gridList[index]})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }